import { render, staticRenderFns } from "./TestDescriptorForm.vue?vue&type=template&id=08ef99f8&scoped=true"
import script from "./TestDescriptorForm.vue?vue&type=script&lang=js"
export * from "./TestDescriptorForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=08ef99f8&prod&scoped=true&lang=css&external"
import style1 from "./TestDescriptorForm.vue?vue&type=style&index=1&id=08ef99f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef99f8",
  null
  
)

export default component.exports